export default {
  name: 'sharing_links',
  component_path: 'modules/procedures/blocks/static/BlockShare'
}